import Grid from '@frontend/storefront/components/grid/index';
import { h2 } from '@frontend/storefront/components/home/styles';
import ProductGridItems from '@frontend/storefront/components/layout/product-grid-items';
import { useStorefrontData } from '@frontend/storefront/data';

export const metadata = {
  title: 'Shop all',
  description: 'Every nopad book.',
};

export default function SearchPage() {
  const products = useStorefrontData().products ?? [];

  return (
    <>
      <h1 className={h2}>Shop all</h1>
      {products.length > 0 ? (
        <Grid className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <ProductGridItems products={products} />
        </Grid>
      ) : null}
    </>
  );
}
